// SoyTiendaPage.jsx
// Route: /tienda
// Assembles: SoyTiendaHeader + all tienda sections + MarketplaceFooter

import React from "react";
import { SoyTiendaHeader }    from "./shared/SoyTiendaHeader";
import { MarketplaceFooter }  from "./shared/MarketplaceFooter";
import { WhatsAppFloat }      from "./shared/WhatsAppFloat";
import { HeroSection }        from "./tienda/HeroSection";
import { StatsStrip }         from "./tienda/StatsStrip";
import { BeneficiosSection }  from "./tienda/BeneficiosSection";
import { ModalidadesSection } from "./tienda/ModalidadesSection";
import { ProcesoSection }     from "./tienda/ProcesoSection";
import { TecnologiaSection }  from "./tienda/TecnologiaSection";
import { CoberturaSection }   from "./tienda/CoberturaSection";
import { PreciosSection }     from "./tienda/PreciosSection";
import { ReferidosSection }   from "./tienda/ReferidosSection";
import { CtaBanner }          from "./tienda/CtaBanner";

export default function SoyTiendaPage() {
  return (
    <div className="min-h-screen bg-slate-50 font-sans antialiased text-slate-900 flex flex-col">
      <SoyTiendaHeader />

      <main className="flex-1">
        <HeroSection />
        <StatsStrip />
        <BeneficiosSection />
        <ModalidadesSection />
        <ProcesoSection />
        <TecnologiaSection />
        <CoberturaSection />
        <PreciosSection />
        <ReferidosSection />
        <CtaBanner />
      </main>

      <MarketplaceFooter />
      <WhatsAppFloat />
    </div>
  );
}